<template>
  <footer class="main-footer">
    <div class="footer-top container">
      <div class="footer__branding">
        <div class="footer-logo">
          <img src="@/assets/DNA-SIS.svg" alt="DNA x SEQUIRE Investor Summit" />
          <p class="footer-tagline">Where innovation. Meets Investment</p>
        </div>
        <div class="footer-event">
          <div class="footer__content--info">
            <h2 class="footer__date">
              Jan 19th - 21st, 2027
            </h2>
            <h3 class="footer__location">
              Condado Vanderbilt, Puerto Rico
            </h3>
            <div class="footer__buttons">
              <a href="https://forms.monday.com/forms/5ab96b8f289480d9d3479556bcc057e0?r=use1" target="_blank">
                <button class="footer__btn">
                  Conference Pass
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M5 12h14M12 5l7 7-7 7"/>
                  </svg>
                </button>
              </a>
              <a href="https://buy.stripe.com/4gM8wOclm2yk27l2la3cc0V" target="_blank">
                <button class="footer__btn-alt">
                  Presenter Pass
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M5 12h14M12 5l7 7-7 7"/>
                  </svg>
                </button>
              </a>
            </div>
          </div>
        </div>
      </div>
      <nav class="footer-nav">
        <a :class="{ active: isActiveRoute('/') }" href="/">Home</a>
        <a :class="{ active: isActiveRoute('/companies') }" href="/companies">Presenting Companies</a>
        <a :class="{ active: isActiveRoute('/venue') }" href="/venue">Venue</a>
        <a :class="{ active: isActiveRoute('/entertainment') }" href="/entertainment">Entertainment</a>
        <a :class="{ active: isActiveRoute('/agenda') }" href="/agenda">Agenda</a>
      </nav>
    </div>

    <hr class="footer-divider" />

    <div class="footer-bottom container">
      <p>©2026 DNA.FUND All Rights Reserved.</p>

      <div class="footer-bottom-links">
        If you have any questions, send us an email at <a href="mailto:puertorico@srax.com">puertorico@srax.com</a>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: "Footer",
  methods: {
    isActiveRoute(route) {
      return this.$route.path === route;
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/styles/components/footer.scss";
</style>